import JourneyPage from "./page"

export default JourneyPage
